import { TaskShortData } from 'api/CailagateApi/api/client';
import { TreeNodeType } from 'components/Tree/types';

export const buildTree = (data: TaskShortData[]): TreeNodeType<TaskShortData>[] => {
  return data.map(item => ({ data: item, id: item.jobId, name: item.jobId, children: buildTree(item.children) }));
};
